import { useState, useEffect } from 'react';

const PROCESSING_MESSAGES = [
  'Processing...',
  'Working on it...',
  'Still processing...',
  'Almost finished...',
] as const;

const MESSAGE_INTERVAL_MS = 5_000; // 5 seconds

/**
 * Hook that cycles through processing messages every 10 seconds
 * @param isProcessing - Whether processing is currently happening
 * @returns The current processing message to display
 */
export const useProcessingMessage = (isProcessing: boolean): string => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    if (!isProcessing) {
      setMessageIndex(0);
      return;
    }

    const intervalId = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % PROCESSING_MESSAGES.length);
    }, MESSAGE_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, [isProcessing]);

  return PROCESSING_MESSAGES[messageIndex];
};

